import { Nav, NavBody, NavFooter, NavList, Sidebar, SidebarToggle } from '@optiaxiom/react';
import {
  IconAngleRight,
  IconBook,
  IconComments,
  IconDatabase,
  IconGear,
  IconScrewdriverWrench,
  IconSparkles,
  IconToggleOff,
} from '@optimizely/axiom-icons';

import { NavigationItem } from '@frontend/components/ui/NavigationItem';
import { useLocalStorage, useOperations } from '@frontend/hooks';
import { OperationsName } from '@frontend/types';

type Route = {
  path: string;
  icon: JSX.Element;
  label: string;
  permission: OperationsName;
  featureFlag?: string;
  footerNav?: boolean;
};

const routes: Route[] = [
  {
    path: 'chat',
    icon: <IconComments />,
    label: 'Chat',
    permission: 'allow_chat',
  },
  {
    path: 'instructions',
    icon: <IconBook />,
    label: 'Instructions',
    permission: 'manage_instructions',
  },
  {
    path: 'agents',
    icon: <IconSparkles />,
    label: 'Agents',
    permission: 'manage_instances',
  },
  {
    path: 'tools',
    icon: <IconScrewdriverWrench />,
    label: 'Tools',
    permission: 'manage_instructions',
  },
  {
    path: 'rag',
    icon: <IconDatabase />,
    label: 'RAG',
    permission: 'manage_instructions',
    featureFlag: 'shamwow-settings-page',
  },
  {
    path: 'connections',
    icon: <IconToggleOff />,
    label: 'Connections',
    permission: 'manage_instances',
  },
  {
    path: 'settings',
    icon: <IconGear />,
    label: 'Settings',
    permission: 'manage_instructions',
  },
] as const;

export const LeftNavbar = () => {
  const { canUser, operations } = useOperations();
  const [sidebarExpanded, setSidebarExpanded] = useLocalStorage('sidebar-expanded', false);

  const allowedOperations = operations
    .filter(operation => operation.allowed)
    .map(operation => operation.name);

  const hasOneOperation = allowedOperations.length === 1;

  if (hasOneOperation) {
    return null;
  }

  const renderNavItem = (route: Route) => (
    <NavigationItem
      key={route.path}
      path={route.path}
      icon={route.icon}
      label={route.label}
      permission={route.permission}
      featureFlag={route.featureFlag}
    />
  );

  const renderNavItems = ({ isFooterNav }: { isFooterNav: boolean }) =>
    routes
      .filter(route => canUser(route.permission) && Boolean(route.footerNav) === isFooterNav)
      .map(renderNavItem);

  return (
    <Sidebar defaultExpanded={sidebarExpanded} onExpandedChange={setSidebarExpanded}>
      <Nav>
        <NavBody>
          <NavList>{renderNavItems({ isFooterNav: false })}</NavList>
        </NavBody>

        <NavFooter>
          <NavList>
            <SidebarToggle icon={<IconAngleRight />} />
            {renderNavItems({ isFooterNav: true })}
          </NavList>
        </NavFooter>
      </Nav>
    </Sidebar>
  );
};
